import { render, staticRenderFns } from "./UpcomingIposTable.vue?vue&type=template&id=231a1920&scoped=true&"
import script from "./UpcomingIposTable.vue?vue&type=script&lang=js&"
export * from "./UpcomingIposTable.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingIposTable.vue?vue&type=style&index=0&id=231a1920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a1920",
  null
  
)

export default component.exports